exports.install = function (Vue, options) {
    Vue.prototype.$setCookie = function (cName, value, expire) {
        var date = new Date()
        date.setSeconds(date.getSeconds() + expire)
        document.cookie = cName + '=' + escape(value) + '; expires=' + date.toGMTString()
    }
    Vue.prototype.$getCookie = function (cName) {
        if (document.cookie.length > 0) {
            let cStart = document.cookie.indexOf(cName + '=')
            if (cStart !== -1) {
                cStart = cStart + cName.length + 1
                let cEnd = document.cookie.indexOf(';', cStart)
                if (cEnd === -1) cEnd = document.cookie.length
                return unescape(document.cookie.substring(cStart, cEnd))
            }
        }
        return ''
    }
 }



// WEBPACK FOOTER //
// ./src/assets/js/cookies.js